<template>
  <button @click="openRoutesList"
          class="mobile-navigator-routes"
  >
    <app-icon icon="is-in-route"
              :is-active="isRoutesListOpen"
    />
  </button>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "MobileNavigatorItemRoutes",
  computed: {
    ...mapState('Interface', ['isRoutesListOpen']),
    ...mapGetters('Interface', ['isRouteDetailsOpen'])
  },
  methods: {
    openRoutesList() {
      this.$emit('before-toggle')

      if (this.$bp.isMdOrLess && !this.isRoutesListOpen) {
        this.closeAllMenus()
      } else if (this.$bp.isMdOrLess && this.isRouteDetailsOpen) {
        this.setActiveRouteId(null)
      }

      this.setRoutesListOpenState(!this.isRoutesListOpen)
    },

    ...mapActions('Interface', ['setRoutesListOpenState', 'closeAllMenus']),
    ...mapActions('Routes', ['setActiveRouteId'])
  }
}
</script>

<style lang="scss">
.mobile-navigator-routes {
  padding: 10px !important;

  .app-icon {
    rect {
      fill: transparent;
    }

    circle, path {
      stroke: $app-primary-color;
    }
    path:last-child {
      fill: $app-primary-color;
    }

    &--is-active {
      circle, path {
        stroke: $app-primary-accent-color;
      }
      path:last-child {
        fill: $app-primary-accent-color;
      }
    }
  }
}
</style>